import React from 'react';

export const CompassIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path id="compass-direction" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.783,5.891-5.09,9.788h0a.5.5,0,0,1-.443.269.481.481,0,0,1-.119-.014.5.5,0,0,1-.382-.486V11.333a.083.083,0,0,0-.083-.083H4.552a.5.5,0,0,1-.231-.943L14.11,5.216a.5.5,0,0,1,.673.675Z"/>
        </svg>
    )
}